<template>
    <div class="container col-sm-12 col-xs-12">
    <h3 style="margin-top:0px;"> <strong> {{mobileNumber}}</strong></h3>
    <div v-if="codeSent">
     <div class="alert alert-danger" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      
      <div class="alert alert-info" v-if="alertMsg">
        <p> {{alertMsg}}</p>
      </div>
      </div>

     <div v-if="!codeSent">
        <div  class="alert alert-info">
          <p>We will generate a 6 digit code and send it to your registered phone, press Generate Code when you are ready</p>
        </div>
            <button class="btn btn-success" @click="sendCode()">Generate Code</button>
       <div>
        </div>
        </div>

        <div class="form-group"  v-if="pending">
                
            <div v-if="codeSent">
            
            <div class="col-xs-6 remove-margins">
    
            <input v-if="pending" pattern="\d*" type="text" class="form-control" placeholder="Verification Code" v-model="code" maxlength="6" autocorrect="off" autocomplete="off" autocapitalize="off" spellcheck="false"></input> 
            </div>
            <div  class="col-xs-6">
                <button style="font-size:small !important;" :disabled="count>1" class="btn btn-info" v-if="pending" @click="sendCode()">Re-Send Code {{count}} </button>
            </div>
            
            </div>
            
            <br>
            <br>
            <div v-if="notReceiving" style="padding:3px;">
            <a @click="notReceivingMessages()" href="javascript:;" >Not receiving messages?</a>
            </div>
            <div class="pull-right">
            <button class="btn btn-default" @click="closePhone()">Close</button>
            </div>
        
    </div>   
    
    <button class="btn btn-default pull-right" v-if="!pending" @click="closePhone()">Close</button>
    
       
    </div>
    
    
    
</template>


<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  
  
  export default {
    props: ['mobileNumber','countryCode'],
    name: 'verifyPhone',
    data() {
      return {  
        code: '',
        error: '',
        notReceiving: false,
        alert: 'Please check your mobile and enter the 6 digits verification code below:',
        pending: true,
        codeSent: false,
        count: '',
    }
    },
    methods: {
      closePhone(){
        $('#verifyPhone').modal('hide')
      },
      startCountDown(){
          var self = this
          self.count=60
          var timer = setInterval(function (){
              self.count--
              if (self.count==0)
              {
                  self.count = ''
                  clearInterval(timer);
                  self.notReceiving=true;
                   
              }
          }, 1000)
      },
      notReceivingMessages(){
        var self = this
               swal({
                            title: 'Cant Receive SMS',
                            text: "Yes its frustrating to wait too long for an SMS! we face this occasionally with some mobile operators in specific countries. please send us an email with your number and we will verify it for you.",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
        },
      sendCode(){
          var self = this
          self.codeSent = true
          $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/api/account/SendMobileCode/' + self.countryCode + '/' + self.mobileNumber,
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert = "Code sent, you will receive an SMS soon with a 6 digit code."
                    self.error = ""
                    self.startCountDown()

            },
            error:function(){
            try {
                    self.error = "Code sending Failed, try again.."
                    self.codeSent = false
            } catch(e)
            {
                self.codeSent = false
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      },
      initVerify(){
           var check = localStorage.getItem('phoneConfirmed')
            if (check == "True"){
                this.pending = false
                this.codeSent = true
                this.alert = 'Has been verified, thank you.'
            }
      },
      verifyCode() {
          self = this
        $.ajax({
            type: 'POST',
            url: 'https://www.dupaws.com/services/api/account/ConfirmPhone?code=' + this.code + '&countryCode=' + self.countryCode + '&phoneNumber=' + self.mobileNumber,
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                localStorage.setItem('phoneConfirmed', 'True')
                store.dispatch('PhoneConfirmed', true)
                
                self.initVerify()
                self.$forceUpdate()
                $('#verifyPhone').modal('hide');
                if (self.userRoleComp=="Client")
                swal({
                    title: "Thank you, Mobile Confirmed",
                    text: "Would you like to save changes and go to Home page?",
                    type: "success",
                    showCancelButton: true,
                    confirmButtonClass: 'btn-success',
                    confirmButtonText: "Save and exit",
                    closeOnConfirm: true,
                    html: true
                    }, function(){
                    self.$parent.updateUser()
                });
                else if (self.userRoleComp=="Sitter")
                swal({
                    title: "Thank you, Mobile Confirmed",
                    text: "Would you like to go to Dashboard to see your profile effectiveness or go to Calendar and set your availability?",
                    type: "success",
                    showCancelButton: true,
                    confirmButtonClass: 'btn-success',
                    cancelButtonClass: 'btn-success',
                    confirmButtonText: "Dashboard",
                    cancelButtonText: "Calendar",
                    closeOnConfirm: true,
                    html: true
                    }, function(isConfirm){
                    if (isConfirm){
                    self.$parent.updateSitter('dashboard')
                    } else {
                        self.$parent.updateSitter('calendar')
                    }
                });
                
            },
            error:function(){
            try {
                self.error = "Verification Failed, try again.."
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      }
    },
    mounted: function() {
            var self = this
            this.initVerify()

           
                

            
    },
    watch:{
        'code': function(){
            if (this.code.length < 6)
            {
                this.error = ''
                return false
            }
            else if (this.code.length==6)
            {
                this.verifyCode()
            }
        },
    },
    computed: {
       
       errorMsg: function(){
           return this.error
       },
       alertMsg: function(){
           return this.alert
       },
       userRoleComp: function(){
           return store.getters.userRole
       }
     
    
  }
  
  }

</script>


<style scoped>
 
</style>


// WEBPACK FOOTER //
// VerifyPhone.vue?3fba6afe